import { TComparison, TCommonSorter } from '../../interfaces/sorting';

export const isGreaterThan: TCommonSorter = (first, second) => first > second ? 1 : -1;

export const compareCaseInsensitive = (first: string, second: string) => {
  return isGreaterThan(first.toUpperCase(), second.toUpperCase());
};
